
import { Component, Mixins } from "vue-property-decorator";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../../system/selectors";
import { IDocumentKindListSelectorDialogCondition, IMultiDocumentKindListSelectorDialogCondition, } from "../";
import { DocumentKind } from "../../../../domain/document";

@Component
export default class MultiOrderableDocumentKindListSelectorDialogMixin extends Mixins(SelectorDialogMixin) implements IMultiSelectableAsynchronously<DocumentKind>, IMultiSelectableConditionallyAsynchronously<DocumentKind, IDocumentKindListSelectorDialogCondition> {
  data(): any {
    return {
      title: this.$wording.format.attributes.name + "種別",
    };
  }
  title: string;

  async selectOptions(defaultOptions?: DocumentKind[]): Promise<DocumentKind[]> {
    return this.show<DocumentKind[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition: IMultiDocumentKindListSelectorDialogCondition, defaultOption?: DocumentKind[]): Promise<DocumentKind[]> {
    return this.show<DocumentKind[]>(defaultOption);
  }
}
